import { NotificationData, notifications } from '@mantine/notifications';

import { NotificationStyleType, NotificationType } from '@/models/notification.ts';

import { useAuthStore } from '@/stores/auth-store.ts';
import { useNotificationStore } from '@/stores/notification-store.ts';

const SUCCESS_NOTIFICATION_DURATION = 5000;
const WARNING_NOTIFICATION_DURATION = 4000;

export const notificationStyle: Record<NotificationType, NotificationStyleType> = {
    [NotificationType.SUCCESS]: {
        autoClose: SUCCESS_NOTIFICATION_DURATION,
        withCloseButton: true,
        loading: false,
    },
    [NotificationType.WARNING]: {
        color: 'yellow',
        withCloseButton: true,
        loading: false,
        autoClose: WARNING_NOTIFICATION_DURATION,
    },
    [NotificationType.ERROR]: {
        color: 'red',
        withCloseButton: true,
        loading: false,
    },
    [NotificationType.LOADING]: {
        loading: true,
        withCloseButton: false,
        autoClose: false,
    },
};

export const showSuccessNotification = (message: string, title?: string): string => {
    const notificationId: string = notifications.show({
        message: message,
        title: title,
        ...notificationStyle[NotificationType.SUCCESS],
    });
    logNotification(title ?? '', message, NotificationType.SUCCESS);
    return notificationId;
};

export const showWarningNotification = (message: string, title?: string): string => {
    const notificationId: string = notifications.show({
        message: message,
        title: title,
        ...notificationStyle[NotificationType.WARNING],
    });
    logNotification(title ?? '', message, NotificationType.WARNING);
    return notificationId;
};

export const showErrorNotification = (message: string, title?: string): string => {
    const notificationId: string = notifications.show({
        message: message,
        title: title,
        ...notificationStyle[NotificationType.ERROR],
    });
    logNotification(title ?? '', message, NotificationType.ERROR);
    return notificationId;
};

export const showLoadingNotification = (message: string, title?: string): string => {
    const notificationId: string = notifications.show({
        message: message,
        title: title,
        ...notificationStyle[NotificationType.LOADING],
    });
    logNotification(title ?? '', message, NotificationType.LOADING);
    return notificationId;
};

export const updateNotification = (type: NotificationType, data: NotificationData): void => {
    if (!data.message) return;
    notifications.update({ ...data, ...notificationStyle[type] });
    logNotification(String((data.title as string | undefined) ?? ''), String(data.message as string), type);
};

export const hideNotification = (notification_id: string): void => {
    notifications.hide(notification_id);
};

export const logNotification = (title: string, message: string, type: NotificationType): void => {
    const userEmail: string = useAuthStore.getState().userEmail;
    if (!userEmail) return;

    useNotificationStore.getState().addNotification(userEmail, {
        title: title,
        message: message,
        type: type,
        timestamp: Date.now(),
    });
};
